<template>
  <La1 id="singleSetting" :ratio="'833px 1fr'">
    <L2 slot="left" :style="{paddingInline: '0'}">
      <template slot="filter">
        <div class="title_name">組合內容</div>
        <Select :defaultValue="area" @input="area=$event" :width="'160px'" :height="'40px'">
          <option :value="null">全部</option>
          <option v-for="(type, t) in restaurants" :key="`s-${t}`" :value="type">{{type}}</option>
        </Select>
        <Select :defaultValue="type" @input="type=$event" :width="'160px'" :height="'40px'">
          <option :value="null">類別</option>
          <option v-for="(type, t) in types" :key="t" :value="type">{{type}}</option>
        </Select>
        <SearchInput :defaultValue="searchText" @input="searchText=$event"/>
      </template>
      <Table :rows="rows">
        <template slot="slot_head">
          <th :style="{textAlign:'start', width: '10em'}">商品ID</th>
          <th :style="{textAlign:'start', width: 'inherit'}">商品名稱</th>
          <th :style="{textAlign:'start', width: '8em'}">類別</th>
          <!-- <th :style="{textAlign:'start'}">餐點用途</th> -->
          <th :style="{textAlign:'center', width: '60px'}">刪除</th>
        </template>
        <tr slot-scope="{item: {id, name, name2, type, sticker, _id},index}" :id="_id"
        @click="$router.replace({ name: $route.name, query: { page: $route.query.page, id: _id } })"
        :class="itemSelected===_id?'selected':''"
        :style="{height: '65px', border: 'none'}">
          <td :style="{textAlign:'start'}">{{id}}</td>
          <td :style="{textAlign:'start'}">{{name}} <span v-if="name2" :style="{color:'#CACACA', fontSize:'smaller'}"><br>{{name2}}</span></td>
          <!-- <td :style="{textAlign:'start'}">{{category}}</td> -->
          <td :style="{textAlign:'start'}">{{type}}</td>
        <td><DelBtn @click="deleteItem={_id, index, name}" :style="{marginInline: 'auto', transform: 'scale(1)'}"></DelBtn></td>
        </tr>
      </Table>
    </L2>
      <ViewCube :types="types" :org="itemS" @update="update" @new="addnew"
      @priceNew="updateAndAdd" @updateMulti="updateMulti"
      :mode="'set'" @createnew="$router.replace({ name: $route.name, query: { page: '新增組合' } })"/>
      <comfirmVue :show="!!deleteItem"  v-if="!!deleteItem" :label="'確認刪除'" :text='`確定要刪除"${deleteItem.name}"嗎?`'
      @confirm="deleteOne(deleteItem._id, deleteItem.index)" @cancel="deleteItem=null"/>
  </La1>
</template>

<script>
import { mapState } from 'vuex'
import ViewCube from './single/view.vue'
import DelBtn from '../../../components/btn/del.vue'
import Select from '../../../components/select.vue'
import L2 from '../../../components/layout/LaTable.vue'
import La1 from '../../../components/layout/La0.vue'
import Table from '../../../components/tables/t2.vue'
import SearchInput from '../../../components/input/search.vue'
import { getapi, deleteapi, postapi } from '../../../store/fetch'
export default {
  props: ['types'],
  components: {
    L2,
    La1,
    Table,
    Select,
    DelBtn,
    ViewCube,
    SearchInput
  },
  data () {
    return {
      deleteItem: null,
      type: null,
      area: null,
      usage: null,
      searchText: null,
      rows: [],
      subpage: '商品內容'
    }
  },
  computed: {
    ...mapState({
      usages: 'usages',
      restaurants: 'restaurants',
      defaultStore: 'defaultStore'
    }),
    itemSelected () {
      return this.$route.query.id || null
    },
    itemS () {
      if (this.itemSelected && this.rows.find(e => e._id === this.itemSelected)) {
        return this.rows.find(e => e._id === this.itemSelected)
      } else {
        return null
      }
    }
  },
  async mounted () {
    this.area = this.defaultStore
    await this.getdata()
    if (!this.$route.query.id && this.rows[0]) this.$router.replace({ name: this.$route.name, query: { ...this.$route.query, id: this.rows[0]._id } })
    if (this.itemSelected) {
      const elem = document.getElementById(this.itemSelected)
      if (elem) elem.scrollIntoView()
    }
  },
  watch: {
    async area () { await this.getdata() },
    async type () { await this.getdata() },
    async searchText () { await this.getdata() }
  },
  methods: {
    async deleteOne (id, index) {
      await deleteapi(`rest_product/set/${id}`)
      this.rows.splice(index, 1)
      this.deleteItem = null
    },
    async updateValue (id, index, sticker) {
      const r = await postapi(`rest_product/set/${id}`, { sticker })
      console.log(r)
      if (r) {
        this.rows.splice(index, 1, r)
      }
    },
    updateAndAdd ({ oldone, newone }) {
      const index = this.rows.map(e => e._id).indexOf(oldone._id)
      this.rows.splice(index, 1, oldone)
      this.rows.splice(index, 0, newone)
    },
    updateMulti (results) {
      results.map(result => {
        const index = this.rows.map(e => e._id).indexOf(result._id)
        this.rows.splice(index, 1, result)
      })
    },
    addnew (ev) {
      this.rows.splice(0, 0, ev)
      this.org = ev
    },
    update (ev) {
      const index = this.rows.map(e => e._id).indexOf(this.itemSelected)
      console.log('update  ----', index, this.rows[index])
      this.rows.splice(index, 1, ev)
    },
    async getdata () {
      const params = {}
      if (this.type) params.type = this.type
      if (this.area) {
        params.area = this.area
        params.visible = true
      }
      if (this.searchText) params.searchText = this.searchText

      this.rows = await getapi('rest_product/set?' + new URLSearchParams(params))
      console.log(this.rows.length)
    }
  }
}
</script>
<style lang="scss">
#singleSetting {
  padding-inline: 18px 0;
  .La0_right {
    max-height: calc(100vh - 89px)!important;
    border-left: 1px solid #CACACA;
    margin-block: 0;
  }
  .La0_left {
    max-height: calc(100vh - 89px)!important;
    margin-right: 0;
  }
}
</style>
<style lang="scss" scoped>
.sticker {
  width: 30px;
  height: 30px;
  background-color: transparent;

}
.title_name {
  font-weight: 500;
  font-size: 28px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: var(--color-pri);
}
</style>
